import { render, staticRenderFns } from "./popup-list.vue?vue&type=template&id=cbd8a548"
import script from "./popup-list.vue?vue&type=script&lang=js"
export * from "./popup-list.vue?vue&type=script&lang=js"
import style0 from "./popup-list.vue?vue&type=style&index=0&id=cbd8a548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports